if (!customElements.get("event-countdown")) {
    class EventCountdown extends HTMLElement {
        constructor() {
            super();
            this.people = this.dataset.numberPeople;
            this.peopleBeginDate = this.dataset.timeOfNumber;
            this.peopleElement = this.querySelectorAll(".event-countdown__number-text span");

            this.countdownElement = this.querySelector(".event-countdown__countdown");
            this.countdownDate = this.countdownElement.dataset.time;
            this.timeDays = this.querySelector("#times_days");
            this.timeHours = this.querySelector("#times_hours");
            this.timeMinutes = this.querySelector("#times_mins");
            this.timeSeconds = this.querySelector("#times_seconds");
        }

        connectedCallback() {
            this.setPeople();
            this.setCountdown();
        }

        setPeople() {
            if (!this.people || !this.peopleBeginDate) {
                console.warn("Wrong data");
                return;
            }

            // 解析 peopleBeginDate，转换为 UTC 时间
            const beginDate = new Date(this.peopleBeginDate + " UTC").getTime();

            if (isNaN(beginDate)) {
                // console.error("peopleBeginDate 解析失败:", this.peopleBeginDate);
                return;
            }

            // 获取当前时间戳（毫秒）
            const now = this.nowTime;

            // 计算时间差（以小时为单位）
            const hoursElapsed = Math.floor((now - beginDate) / (1000 * 60 * 60));

            if (hoursElapsed < 0) {
                // console.warn("开始时间在未来，人数不变");
                this.peopleElement.forEach((el) => {
                    el.textContent = this.people;
                });
                return;
            }

            // 计算增长后的人数，每小时递增 20%
            const growthRate = 1.2; // 20% 增长
            const updatedPeople = Math.floor(this.people * Math.pow(growthRate, hoursElapsed));

            // 更新所有匹配的元素内容
            this.peopleElement.forEach((el) => {
                el.textContent = updatedPeople;
            });

            // console.log("开始时间 (UTC):", new Date(beginDate).toISOString());
            // console.log("当前时间 (UTC):", new Date(now).toISOString());
            // console.log("经过的小时数:", hoursElapsed);
            // console.log("更新后的人数:", updatedPeople);
        }

        get nowTime() {
            return new Date().getTime();
        }

        setCountdown() {
            if (!this.countdownDate) {
                // console.warn("倒计时时间缺失");
                return;
            }

            // 解析倒计时目标时间，并转换为 UTC 时间
            const targetTime = new Date(this.countdownDate + " UTC").getTime();

            if (isNaN(targetTime)) {
                // console.error("倒计时时间解析失败:", this.countdownDate);
                return;
            }

            // 更新倒计时的函数
            const updateCountdown = () => {
                const now = this.nowTime;
                const timeDiff = targetTime - now;

                if (timeDiff <= 0) {
                    // 如果时间到达或已过，倒计时归零
                    this.timeDays.textContent = "00";
                    this.timeHours.textContent = "00";
                    this.timeMinutes.textContent = "00";
                    this.timeSeconds.textContent = "00";

                    clearInterval(this.countdownInterval);
                    console.log("Countdown finished");
                    return;
                }

                // 计算天、小时、分钟、秒
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                // 更新倒计时 DOM
                this.timeDays.textContent = days.toString().padStart(2, "0");
                this.timeHours.textContent = hours.toString().padStart(2, "0");
                this.timeMinutes.textContent = minutes.toString().padStart(2, "0");
                this.timeSeconds.textContent = seconds.toString().padStart(2, "0");
            };

            // 先执行一次更新，确保倒计时立即显示正确的数值
            updateCountdown();

            // 每秒更新倒计时
            this.countdownInterval = setInterval(updateCountdown, 1000);
        }

        disconnectedCallback() {

        }
    }

    customElements.define('event-countdown', EventCountdown);
}